import jQuery from 'jquery';
import 'slick-carousel';

jQuery(function ($) {
    'use strict';

    const $testimonialCarousel = $('.testimonial-carousel');

    $testimonialCarousel.each(function () {
        let $this = $(this);

        $this.find('.testimonial-carousel__slides').slick({
            arrows: true,
            prevArrow: $(this).find('.slick-prev'),
            nextArrow: $(this).find('.slick-next'),
            dots: true,
            autoplay: false,
            autoplaySpeed: 8000,
            infinite: true,
            slidesToShow: 1,
            adaptiveHeight: true,
        });
    });
});
